import { render, staticRenderFns } from "./build-it-yourself.vue?vue&type=template&id=518931ed&scoped=true&"
import script from "./build-it-yourself.vue?vue&type=script&lang=js&"
export * from "./build-it-yourself.vue?vue&type=script&lang=js&"
import style0 from "./build-it-yourself.vue?vue&type=style&index=0&id=518931ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518931ed",
  null
  
)

export default component.exports